export const etyleneGlycol = {
  0: 0,
  5: -1.4,
  10: -3.2,
  15: -5.4,
  20: -7.8,
  25: -10.7,
  30: -14.1,
  35: -17.9,
};

export const propyleneGlycol = {
  0: 0,
  5: -1.6,
  10: -3.3,
  15: -5.1,
  20: -7.1,
  25: -9.6,
  30: -12.7,
  35: -16.4,
};
